import { render } from "./datiBaseUser.vue?vue&type=template&id=0311fb81&ts=true"
import script from "./datiBaseUser.vue?vue&type=script&lang=ts"
export * from "./datiBaseUser.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__